import { createFileRoute } from '@tanstack/react-router';
import CandidatesTemplate from '@/features/agent/candidates/templates/CandidatesTemplate';

export const Route = createFileRoute('/agent/candidates/')({
  component: Candidates,
  staticData: { title: '求職者管理' },
});

function Candidates() {
  return <CandidatesTemplate />;
}
